export default "__VITE_ASSET__BGEjN5nN__"